import { useSnapshot } from "valtio";
import * as XLSX from "xlsx";
import { aguserStore, configStore, dataListStore, loginStore } from "../state/CommonState";
import Utils from "../util/Utils";
import MonApi from "../state/mongo-api";
import { getTC } from "../TC";
import Api from "../state/Api";
import AguserApi from "../state/AguserApi";
import { useEffect } from "react";
import { loader } from "../util/loader";
import { currencyList } from "../StaticData";
export default function CartingBooking() {
  useSnapshot(configStore);
  useSnapshot(aguserStore);
  useSnapshot(dataListStore);
  useSnapshot(loginStore)
  const GET_MAP_UNLOC_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/common/getmapunloc`;
  let packagetype = {
    pallet: "Pallet",
    drum: "Drum",
    crate: "Crate",
    skid: "Skid",
    "loose cartons": "Loose Cartons",
    box: "Box",
    bales: "Bales",
    rolls: "Rolls",
  };

  let containerTypeList = {
    "20'std": "20'STD",
    "40'std": "40'STD",
    "40'hc": "40'HC",
    "45'hc": "45'HC",
    "20'fr (in-gauge)": "20'FR (In-gauge)",
    "40'fr (in-gauge)": "40'FR (In-gauge)",
    "20'ot (in-gauge)": "20'OT (In-gauge)",
    "40'ot (in-gauge)": "40'OT (In-gauge)",
  };

  let incoTermsList = {
    "exw (ex-works)": "EXW (Ex-works)",
    "fca (free-carrier)": "FCA (Free-Carrier)",
    "fas (free-alongside-ship)": "FAS (Free-Alongside-Ship)",
    "fob (free-on-board)": "FOB (Free-on-Board)",
    "cfr (cost and freight)": "CFR (Cost and Freight)",
    "cif (cost, insurance and freight)": "CIF (Cost, Insurance and Freight)",
    "cpt (carriage paid to)": "CPT (Carriage Paid To)",
    "cip (carriage and insurance paid to)":
      "CIP (Carriage and Insurance Paid To)",
    "dap (delivered at place)": "DAP (Delivered at Place)",
    "dpu (delivered place unloaded)": "DPU (Delivered Place Unloaded)",
    "ddp (delivered duty paid)": "DDP (Delivered Duty Paid)",
  };

  let commodityList = {
    machinery: "Machinery",
    "spare parts": "Spare Parts",
    antennas: "Antennas",
    equipment: "Equipment",
    plastic: "Plastic",
    "containerized general merchandise": "Containerized general merchandise",
    "medical equipment": "Medical Equipment",
    "automotive spare parts & components":
      "Automotive Spare Parts & Components",
    rubber: "Rubber",
    timber: "Timber",
    "metal - steels, zinc, lead, aluminum, copper sheets or ingots or coils, high-value electronic scrap":
      "Metal - Steels, Zinc, Lead, Aluminum, Copper Sheets or Ingots or Coils, High-value electronic scrap",
    "packaged food items (canned, dry fruits & nuts, dressings, cinnamon, spices, rice, sugar of any kind excluding only raw sugar, coffee/ tea, milk powder)":
      "Packaged Food Items (Canned, Dry Fruits & Nuts, Dressings, Cinnamon, Spices, Rice, Sugar of any kind excluding only raw sugar, Coffee/ Tea, Milk Powder)",
    "leather & finished leather products":
      "Leather & Finished Leather Products",
    "textiles/ fabrics/ apparel/ accessories/ footwear":
      "Textiles/ Fabrics/ Apparel/ Accessories/ Footwear",
    toys: "Toys",
    "wheels and tyres": "Wheels and Tyres",
    "casino machines": "Casino Machines",
    "raw materials in general classified as high risk":
      "Raw materials in general classified as high risk",
    "raw or bulk polypropylene, polyethylene and latex":
      "Raw or bulk polypropylene, polyethylene and latex",
    "biomedical, pharmaceutical and veterinary products, other than animal food":
      "Biomedical, Pharmaceutical and Veterinary products, other than animal food",
    "non-hazardous chemicals (including agrochemicals, fungicides, insecticides, fertilizers)":
      "Non-Hazardous Chemicals (including agrochemicals, fungicides, insecticides, fertilizers)",
    "wood and wooden articles": "Wood and wooden articles",
    "fragile items such as tableware, ceramics, glass, among other":
      "Fragile items such as tableware, ceramics, glass, among other",
    "cigarettes, tobacco, spirits, beers, wines, and similar products":
      "Cigarettes, tobacco, spirits, beers, wines, and similar products",
    "business personal computers or laptops, computer parts such as displays, hard drives, modems, electronic cards or their spare parts":
      "Business personal computers or laptops, computer parts such as displays, hard drives, modems, electronic cards or their spare parts",
    "printers and their parts": "Printers and their parts",
    "sound equipment": "Sound equipment",
    "video games and consoles": "Video games and consoles",
    "video, tv or photography cameras": "Video, TV or Photography cameras",
    "televisions - leds, lcds, flat screens, plasmas or the like":
      "Televisions - LEDs, LCDs, Flat screens, Plasmas or the like",
    "appliances such as refrigerators, washing machines, portable air conditioners, dryers, blenders, kitchen and other home appliances":
      "Appliances such as refrigerators, washing machines, portable air conditioners, dryers, blenders, kitchen and other home appliances",
    "articles related to covid (medical implements, masks, tests, antibacterial, among others)":
      "Articles related to COVID (medical implements, masks, tests, antibacterial, among others)",
  };

  let cartingkeys = [
    "Type(LCL/FCL/Air) *",
    "Shipper Name *",
    "Address *",
    "Shipping Bill No *",
    "Shipping Bill Date(DD-MM-YYYY) *",
    "CartingDate(DD-MM-YYYY) *",
    "Consignee Name *",
    "Consignee Address *",
    "CHA Name *",
    "CHA Number *",
    "CFS Location *",
    "Carted At *",
    "POL *",
    "POD *",
    "FPOD *",
    "Net Weight *",
    "Package Type *",
    "Quantity *",
    "Total Weight(Kgs) *",
    "Total Volume(CBM) *",
    "IEC Code",
    "Leo Date & Time(DD-MM-YYYYTHH:MM)",
    "Invoice No",
    "Marks & Nos",
    "HS Code",
    "Commodity Type",
    "Customer Name(Entity Code #)",
    "Relationship Manager (Email)",
    "Customer Service (Email)",
    "SHED Location",
    "Routing",
    "Reefer(Yes/No)",
    "Top Loading(Yes/No)",
    "Fumigation(Yes/No)",
    "Head Load(Yes/No)",
    "Door Load(Yes/No)",
    "Remarks",
  ];

  const isValidDateTime = (str) => {
    const regex =
      /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4} (0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/;
    return regex.test(str);
  };
  const convertDateFormat = (str) => {
    const [datePart, timePart] = str.split(" ");
    const [dd, mm, yyyy] = datePart.split("-");
    return `${yyyy}-${mm}-${dd}T${timePart}`;
  };
  const isValidDate = (str) => {
    const regex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/;
    return regex.test(str);
  };
  const convertDate = (str) => {
    const [dd, mm, yyyy] = str.split("-");
    return `${yyyy}-${mm}-${dd}`;
  };

  useEffect(() => {
      Api.getFCLCarrierList();
      AguserApi.getList();
    }, []);

  const getBookingdata = async (email, type, data, branch,entity) => {
    console.log(email, type, data, branch,entity)
    let tc = getTC(type);
    let chargelist = []
    let k = Object.keys(data['charges'])
    for (let i = 0; i < k.length; i++) {
      if(type=='LCL'){
        chargelist.push({
                    "chargeDescription": k[i],
                    "isIncluded": "Yes",
                    "perShipment": data['charges'][k[i]],
                    "onaccount": "On Your Account",
                    "currency": data['chargescur'][k[i]],
                    "perCBM": 0,
                    "perTon": 0,
                    "minimum": 0,
                    "maximum": 0,
                    "total": data['charges'][k[i]]
                })
      }else{
        let c = {
        "chargeDescription": k[i],
        "currency": data['chargescur'][k[i]],
        "onaccount": "On Your Account",
        "isIncluded": "Yes"
      }
      c[data["Container Type *"]+"perWM"] = data['charges'][k[i]]
      c[data["Container Type *"]+"perShipment"] = 0
      c[data["Container Type *"]+"total"] = data["Number of Containers *"]*data['charges'][k[i]]
        chargelist.push(c)
      }
    }
    
    let consolidatorList = null;
    let cargo = [{
                           "id": 0,
                            "packageType": "",
                            "numPackages": "",
                            "wtPerPackage": 0,
                            "length": 0,
                            "width": 0,
                            "height": 0,
                            "volPerPackage": 0,
                            "totalWeight": 0,
                            "totalVolume": 0,
                            "chargeableWeight": 0
                        }]
    let containerList = [
                {
                    "id": 0,
                    "containerType": "",
                    "numContainers": 0,
                    "wtPerContainer": 0,
                    "unit": "Kgs"
                }
            ]
    if(type=='LCL'){
      cargo[0]["packageType"] = data["Package Type *"]
      cargo[0]["numPackages"] = data["Quantity *"]
      cargo[0]["totalWeight"] = data["Total Weight(Kgs) *"]
      cargo[0]["totalVolume"] = data["Total Volume(CBM) *"]
    }else{
      containerList[0]["containerType"] = data["Container Type *"]
      containerList[0]["numContainers"] = data["Number of Containers *"]
      containerList[0]["wtPerContainer"] = data["Weight Per Container(Kgs) *"]
    }
    let multidest = [
                {
                    "destination": data["Destination *"],
                    "cargoDetails": cargo
                }
            ]
            let Carrier = ""
           if(type=='LCL'){
            Carrier = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE
           }

    if (type == "LCL") {
      consolidatorList = [
        {
          scacCode: "WAIC",
          consolidatorAbbrName: "Team Global",
          consolidatorName: "Teamglobal Logistics Pvt Ltd",
        },
        {
          scacCode: "GLOL",
          consolidatorAbbrName: "Globelink",
          consolidatorName: "Globelink WW India Pvt.Ltd",
        },
        {
          scacCode: "ECUI",
          consolidatorAbbrName: "Allcargo",
          consolidatorName: "Allcargo Logistics Limited",
        },
        {
          scacCode: "DTCL",
          consolidatorAbbrName: "Vanguard",
          consolidatorName: "Vanguard Logistics Service",
        },
        {
          scacCode: "CPWL",
          consolidatorAbbrName: "CP World",
          consolidatorName: "C P World Logistics India Pvt Ltd",
        },
        {
          scacCode: "EMUM",
          consolidatorAbbrName: "EMU",
          consolidatorName: "Emu Lines Pvt Ltd",
        },
        {
          scacCode: "CPWB",
          consolidatorAbbrName: "Total Transport",
          consolidatorName: "Total Transport Systems Ltd",
        },
        {
          scacCode: "SACCON",
          consolidatorAbbrName: "SACCON Lines",
          consolidatorName: "SACCON Lines India Pvt Ltd",
        },
        {
          scacCode: "MACOLINE",
          consolidatorAbbrName: "MACOLINE",
          consolidatorName: "MACOLINE Shipping Pvt Ltd",
        },
        {
          scacCode: "GLOBAL",
          consolidatorAbbrName: "Global Logistics",
          consolidatorName: "Global Logistics Solutions India Pvt Ltd",
        },
        {
          scacCode: "WORLDGATE",
          consolidatorAbbrName: "Worldgate Express",
          consolidatorName: "Worldgate Express Lines International Pvt Ltd",
        },
        {
          scacCode: "CARGOCON",
          consolidatorAbbrName: "Cargo Console",
          consolidatorName: "Cargo Console",
        },
        {
          scacCode: "MACNEL",
          consolidatorAbbrName: "Mac-Nels",
          consolidatorName: "Mac-Nels Container Lines Pvt Ltd",
        },
        {
          scacCode: "LINKER",
          consolidatorAbbrName: "Linkers India Logistics Pvt. Ltd",
          consolidatorName: "Linkers India Logistics Pvt. Ltd",
        },
        {
          scacCode: "IMAV",
          consolidatorAbbrName: "Freight Bridge Logistics",
          consolidatorName: "Freight Bridge Logistics Pvt. Ltd",
        },
        {
          scacCode: "CUIA",
          consolidatorAbbrName: "CTL LOGISTICS ( INDIA) PRIVATE LIMITED",
          consolidatorName: "CTL LOGISTICS ( INDIA) PRIVATE LIMITED",
        },
        {
          scacCode: "UFMA",
          consolidatorAbbrName: "UNITED FREIGHT MANAGEMENT PVT LTD",
          consolidatorName: "UNITED FREIGHT MANAGEMENT PVT LTD",
        },
        {
          scacCode: "GBOR",
          consolidatorAbbrName: "GREENWICH MERIDIAN LOGISTICS INDIA PVT LTD",
          consolidatorName: "GREENWICH MERIDIAN LOGISTICS INDIA PVT LTD",
        },
        {
          scacCode: "GGLQ",
          consolidatorAbbrName:
            "FM GLOBAL CONSOLIDATION SERVICES PRIVATED LIMITED",
          consolidatorName: "FM GLOBAL CONSOLIDATION SERVICES PRIVATED LIMITED",
        },
        {
          scacCode: "YLIP",
          consolidatorAbbrName: "Yasuda Logistics",
          consolidatorName: "Yasuda Logistics India Private Limited",
        },
        {
          scacCode: "MGLP",
          consolidatorAbbrName: " MATSU GLOBAL",
          consolidatorName: " MATSU GLOBAL LOGISTICS PRIVATE LIMITED ",
        },
      ];
    }
    let today = new Date();
  let year = today.getFullYear();
  let month = today.getMonth(); 
  let endDate = new Date(year, month + 1, 0);
  let validUpto = endDate.toISOString().split("T")[0];
    let b = {
      bookingData: {
        isUpload:"Yes",
        _id: "",
        bookingDate: data["BookingDate(DD-MM-YYYY) *"],
        status: "SUBMITTED",
        contractNum: "SPOT",
        branchId: data["branchId *"],
        erpJobId: "",
        erpBookingId: "",
        contract: {
          isFBA: false,
          fbaPallets: 0,
          cbm: 1,
          charges: {},
          shippercharges: {},
          consigneecharges: {},
          tc: [],
          terms: {
            your: [],
            shipper: [],
            consignee: [],
          },
          sender: email,
          salesperson: "",
          customerService: "",
          quoteSenderEmail: "",
          customerEmail: "",
          entityName: entity['entityName'],
          entityId: data["entityId *"],
          emails: "",
          shipmentType: type,
          shipmentScope: "Port-to-Port",
          origin: data["Origin *"],
          destination: data["Destination *"],
          cargoReadinessDate: data["Cargo ReadinessDate(DD-MM-YYYY) *"],
          portOfLoading: data["POL *"],
          portOfDischarge: data["POD *"],
          originAirport: "",
          destinationAirport: "",
          portOfReceipt: data["POR *"],
          finalPlaceOfDelivery: data["FPOD *"],
          isfromAgragaEnquiry: "",
          countryFromEnquiry: "",
          customerReferenceNum: "",
          validUpto: validUpto,
          hazardous: "No",
          quoteClass: "",
          packingGroup: "",
          unnumber: "",
          nonStackable: "No",
          commodityType: data["Commodity Type *"],
          incoTerms: data["IncoTerms *"],
          carrier: Carrier,
          transitTime: 0,
          factoryOrDockStuffing: "",
          stuffingType: "Factory",
          deStuffingType: "Factory",
          temperatureControlled: "No",
          temperature: 0,
          cargoValue: 0,
          minTemperature: "",
          maxTemperature: "",
          airline: "",
          exchangeUSD2INR: 0,
          exchangeSpecif2INR: 0,
          customTC: "",
          status: "UPLOAD_SCHEDULES",
          mailedOn: "2025-09-05",
          isFromEnquiry: true,
          consolidatorList: consolidatorList,
          outCome: "",
          quoteStatus: "DRAFT(Enquiry)",
          decline_reason: "",
          tsDeclineBy: "",
          tsDeclineOn: "",
          LostReason: "",
          tsLostBy: "",
          tsLostOn: "",
          InvalidReason: "",
          tsInvalidBy: "",
          tsInvalidOn: "",
          tsWonBy: "",
          tsWonOn: "",
          vehicleDetails: {
            fields: {
              tataAce: "Tata Ace",
              bolero: "Bolero",
              trailer14: "14 Foot Trailer",
              tata407: "Tata 407",
              trailer20: "20 Foot Trailer",
              trailer24: "24 Foot Trailer",
              sxl32: "32 Foot SXL",
              mxl32: "32 Foot MXL",
            },
            fieldkeys: [
              "tataAce",
              "bolero",
              "trailer14",
              "tata407",
              "trailer20",
              "trailer24",
              "sxl32",
              "mxl32",
            ],
            tataAce: 0,
            bolero: 0,
            trailer14: 1,
            tata407: 0,
            trailer20: 0,
            trailer24: 0,
            sxl32: 0,
            mxl32: 0,
          },
          procurement: "",
          fba: "No",
          pick_up_by_amazon: "No",
          hasToShowDummySchedule: true,
          _id: "undefinedC",
          fbaIorRequired: "No",
          fbaOCC: "No",
          fbaDCC: "No",
          fbaPAL: "Yes",
          fbaSAD: "No",
          fbaSurvey: "No",
          fbaDays: 0,
          multidest: multidest,
          containerList: containerList,
          cargoList: cargo,
          chargesList: chargelist,
          customTerms: [],
          validFrom: "2025-09-05",
          contractRefNum: "undefinedC",
          mode: "QUOTE",
          quoteFinalizedDate: "2025-09-05",
          emailBody: "",
          toEmails: "",
          ccEmails: "",
          mailSent: "PENDING",
          scheduleUploadedOn: "",
          contractCreatedOn: "",
          createdOn: "2025-09-05",
          tsCreatedOn: "2025-09-05T11:29:12.105Z",
          tsCreatedBy: "satheesh.c@agraga.com",
          temptc: tc,
          schedules: [],
          logId: "1757071752098",
          reworkingPort: "",
          shipperchargesList: [],
          consigneechargesList: [],
          quotationNum: "SPOT",
          quoteValueDeduction: 0,
        },
        schedule: {},
        usermail: "",
        firstName: "",
        lastName: "",
        phone: "",
        emailid: "",
        company: entity['entityName'],
        address: branch.branchAddresses[0].address,
        pin: branch.branchAddresses[0].pincode,
        country: branch['country'],
        incoTerms: data["IncoTerms *"],
        isfromAgragaEnquiry: "",
        checkAgCustomer: "",
        commodityType: data["Commodity Type *"],
        specialInstructions: "",
        carrierMBL: "No",
        msds_filename: "",
        dgdecl_filename: "",
        nondgdecl_filename: "",
        iipcert_filename: "",
        commercialInvoice_filename_list: [],
        packingList_filename_list: [],
        specialInstructions_filename_list: [],
        custbookingconf_filename_list: [],
        commercialInvoiceList: [],
        packingList: [],
        carrierReleaseOrderList: [],
        blDraftList: [],
        awbDraftList: [],
        finalAWBList: [],
        finalBlList: [],
        freightInvoiceList: [],
        customsTaxesDutiesList: [],
        localChargesInvoiceList: [],
        podList: [],
        deliveryOrderList: [],
        measurementSlipList: [],
        shippingInstructionList:[],
        isInsured: "No",
        hasToShowDummySchedule: true,
        fba: "No",
        merchantID: "",
        fbaDetails: "",
        sendMilestoneAlert: false,
        vendor: {},
        contractRefNum: "SPOT",
        createdFromPricing: true,
        flexiBooking: true,
        entityId: data["entityId *"],
        originCount: "India",
        destinationCount: "United States",
        blType: "Seaway",
        consignee: "",
        shipper: "TATA Mototrs",
        paymentType: "Prepaid",
      },
      shipperConsignee: {
        _id: "",
        firstName: "",
        lastName: "",
        emailId: "",
        mobileNumber: "",
        companyName: "",
        address: "",
        pincode: "",
        country: "United States",
        role: "consignee",
        city: "",
        state: "",
        newShipper: false,
        linkedEntity: "",
        toUsers: ["Ocean export Coordination"],
      },
    };
    if(type!="LCL"){
      b.bookingData.contract.cargoList = []
      b.bookingData.contract.carrier = data["SCAC *"]
      b.bookingData.contract.scac = data["SCAC *"]
    }
    let country = branch.country;
    let originCount = Utils.extractCodeAndReturnCountry(b.bookingData.contract.portOfReceipt);
    let destinationCount = Utils.extractCodeAndReturnCountry(
      b.bookingData.contract.finalPlaceOfDelivery
    );
    let cecOc = false;
    let cecOd = false;
    if (country === originCount) {
      cecOc = true;
    }
    if (country === destinationCount) {
      cecOd = true;
    }
    let shipperSearch = ""
    if (cecOc){
            b.shipperConsignee.role = "consignee"
            b.bookingData.consignee = shipperSearch
            b.bookingData.shipper = b.bookingData.company
        }else{
            b.shipperConsignee.role = "shipper"
            b.bookingData.shipper = shipperSearch
            cecOd?b.bookingData.consignee = b.bookingData.company: b.bookingData.consignee = ""

        }
    let role = [];
    //Ocean
    if (cecOc) {
      role.push("Ocean export Coordination");
    }
    if (cecOd) {
      role.push("Ocean Import Coordination");
    }
    if (!cecOc && !cecOd) {
      role.push("Ocean export Coordination");
      role.push("Ocean Import Coordination");
    }

    b.shipperConsignee.toUsers = role;
    let bdata = await MonApi.apost(`${process.env.REACT_APP_API_SERVER}/api/v1/bookings`, b);
    return bdata
  };
  const formatDate=(date)=>{
        console.log(date)
        const istOffset = 330 * 60 * 1000;
        let da = new Date(new Date(date).getTime() + istOffset)
        console.log(da)
        let d = da.getDate().toString().padStart(2, "0");
        let m = (da.getMonth() + 1).toString().padStart(2, "0");
        let y = da.getFullYear();
        return `${d}-${m}-${y}`;
      }
  const change = (parent,files) => {
    const file = files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = async (e) => {
      loader.show()
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array", cellDates: true });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const data1 = XLSX.utils.sheet_to_json(sheet);
      let ca = ["INTKD", "INAMD", "INBLR", "INHYD", "INNSA"];
      let un = {
        INTKD: "ICD Tughlakabad, India (INTKD)",
        INAMD: "Ahmedabad, India (INAMD)",
        INBLR: "Bangalore, India (INBLR)",
        INHYD: "Hyderabad, India (INHYD)",
        INNSA: "Nhava Sheva, India (INNSA)",
      };
      let m = [
        "Type(LCL/FCL/Air) *",
        "Shipper Name *",
        "Address *",
        "Shipping Bill No *",
        "Shipping Bill Date(DD-MM-YYYY) *",
        "CartingDate(DD-MM-YYYY) *",
        "Consignee Name *",
        "Consignee Address *",
        "CHA Name *",
        "CHA Number *",
        "CFS Location *",
        "Carted At *",
        "POL *",
        "POD *",
        "FPOD *",
        "Net Weight *",
        "Package Type *",
        "Quantity *",
        "Total Weight(Kgs) *",
        "Total Volume(CBM) *",
      ];
      let y = [
        "Nomination(Yes/No)",
        "Bank Involved(Yes/No)",
        "Reefer(Yes/No)",
        "Top Loading(Yes/No)",
        "Fumigation(Yes/No)",
        "Head Load(Yes/No)",
        "Door Load(Yes/No)",
      ];
      let n = [
        "Net Weight *",
        "Quantity *",
        "Total Weight(Kgs) *",
        "Total Volume(CBM) *",
      ];
      let err = "";
      let unloc = [];
      let enitty = [];
      let email = [];
      let jd = [];

      const jsonData = data1.map((row) => {
        Object.keys(row).forEach((key) => {
          if (row[key] instanceof Date) {
            row[key] = formatDate(row[key]);
          }
        });
        return row;
      });
      if(jsonData.length==0){
        err = "No data"
      }
      for (let i = 0; i < jsonData.length; i++) {
        if (err.length == 0) {
          let l1 = jsonData[i];
          let k = Object.keys(l1);
          for (let j = 0; j < k.length; j++) {
            if (l1[k[j]] != undefined) {
              l1[k[j]] = l1[k[j]].toString().trim();
            }
          }
          for (let j = 0; j < m.length; j++) {
            if (l1[m[j]] == undefined || l1[m[j]].length == 0) {
              err = "Row " + (i + 2) + ": Required - " + m[j];
              j = m.length + 1;
            }
          }
          if (err.length == 0) {
            let lt = l1["Type(LCL/FCL/Air) *"];
            if (lt != "LCL" && lt != "FCL" && lt != "Air") {
              err = "Row " + (i + 2) + ": Invalid Value - Type(LCL/FCL/Air) *";
            }
          }
          if (err.length == 0) {
            for (let j = 0; j < y.length; j++) {
              if (l1[y[j]] != undefined) {
                let l2 = l1[y[j]].toLowerCase();
                if (l2.length != 0) {
                  if (l2.indexOf("yes") != -1 || l2.indexOf("no") != -1) {
                    if (l2.indexOf("yes") != -1) {
                      l1[y[j]] = true;
                    } else {
                      l1[y[j]] = false;
                    }
                  } else {
                    err = "Row " + (i + 2) + ": Invalid Value - " + y[j];
                    j = y.length + 1;
                  }
                } else {
                  l1[y[j]] = false;
                }
              } else {
                l1[y[j]] = false;
              }
            }
          }
          if (err.length == 0) {
            for (let j = 0; j < n.length; j++) {
              let l3 = Utils.toNum(l1[n[j]]);
              if (l3 != 0) {
                l1[n[j]] = l3;
              } else {
                err = "Row " + (i + 2) + ": Invalid Value - " + n[j];
              }
            }
          }
          if (err.length == 0) {
            let lca = Utils.getUNCodeFromLocationString(
              l1["Carted At *"]
            ).toUpperCase();
            if (ca.indexOf(lca) != -1) {
              l1["Carted At *"] = un[lca];
            } else {
              err =
                "Row " +
                (i + 2) +
                ": Invalid Unloc - Carted At *(" +
                ca.join(",") +
                ")";
            }
          }
          if (err.length == 0) {
            let pt = packagetype[l1["Package Type *"].toLowerCase()];
            if (pt == undefined) {
              err =
                "Row " +
                (i + 2) +
                ": Invalid Package Type - (" +
                Object.values(packagetype).join(",") +
                ")";
            }
          }
          let ld = l1["Leo Date & Time(DD-MM-YYYYTHH:MM)"];
          if (err.length == 0 && ld != undefined && ld.length > 0) {
            ld = ld.replace("T", " ");
            if (!isValidDateTime(ld)) {
              err =
                "Row " +
                (i + 2) +
                ": Invalid Format - Leo Date & Time(DD-MM-YYYYTHH:MM)";
            } else {
              l1["Leo Date & Time(DD-MM-YYYYTHH:MM)"] = convertDateFormat(ld);
            }
          }
          if (err.length == 0) {
            if (!isValidDate(l1["CartingDate(DD-MM-YYYY) *"])) {
              err =
                "Row " +
                (i + 2) +
                ": Invalid Format - CartingDate(DD-MM-YYYY) *";
            } else {
              l1["CartingDate(DD-MM-YYYY) *"] = convertDate(
                l1["CartingDate(DD-MM-YYYY) *"]
              );
            }
          }
          if (err.length == 0) {
            if (!isValidDate(l1["Shipping Bill Date(DD-MM-YYYY) *"])) {
              err =
                "Row " +
                (i + 2) +
                ": Invalid Format - Shipping Bill Date(DD-MM-YYYY) *";
            } else {
              l1["Shipping Bill Date(DD-MM-YYYY) *"] = convertDate(
                l1["Shipping Bill Date(DD-MM-YYYY) *"]
              );
            }
          }
          if (err.length == 0) {
            unloc.push(
              Utils.getUNCodeFromLocationString(l1["POL *"]).toUpperCase()
            );
            unloc.push(
              Utils.getUNCodeFromLocationString(l1["POD *"]).toUpperCase()
            );
            unloc.push(
              Utils.getUNCodeFromLocationString(l1["FPOD *"]).toUpperCase()
            );
            if (l1["Routing"] != undefined && l1["Routing"].length > 0) {
              unloc.push(
                Utils.getUNCodeFromLocationString(l1["Routing"]).toUpperCase()
              );
            }
            if (
              l1["Customer Name(Entity Code #)"] != undefined &&
              l1["Customer Name(Entity Code #)"].length > 0
            ) {
              enitty.push(l1["Customer Name(Entity Code #)"]);
            }
            if (
              l1["Relationship Manager (Email)"] != undefined &&
              l1["Relationship Manager (Email)"].length > 0
            ) {
              email.push(l1["Relationship Manager (Email)"]);
            }
            if (
              l1["Customer Service (Email)"] != undefined &&
              l1["Customer Service (Email)"].length > 0
            ) {
              email.push(l1["Customer Service (Email)"]);
            }
          }
          for (let j = 0; j < cartingkeys.length; j++) {
            if (l1[cartingkeys[j]] == undefined) {
              l1[cartingkeys[j]] = "";
            }
          }
          jd.push(l1);
        } else {
          i = jsonData.length + 1;
        }
      }
      let emaillist = {};
      if (err.length == 0) {
        unloc = unloc.filter((item, index) => unloc.indexOf(item) === index);
        enitty = enitty.filter((item, index) => enitty.indexOf(item) === index);
        email = email.filter((item, index) => email.indexOf(item) === index);
        if (enitty.length > 0) {
          let enlist = await MonApi.find(
            "SHEntities",
            { entityId: { $in: enitty } },
            { entityId: 1 }
          );
          if (enlist.length == 0) {
            err =
              "Entity Code # Not found our system (" + enitty.join(",") + ")";
          } else {
            let entityIds = enlist.map((item) => item.entityId);
            let e = enitty.filter((e) => !entityIds.includes(e));
            if (e.length > 0) {
              err = "Entity Code # Not found our system (" + e.join(",") + ")";
            }
          }
        }
      }
      if (err.length == 0) {
        if (email.length > 0) {
          let emlist = await MonApi.find(
            "Agusers",
            { email: { $in: email } },
            {}
          );
          if (emlist.length == 0) {
            err = "EmailID Not found our system (" + emlist.join(",") + ")";
          } else {
            let emIds = emlist.map((item) => item.email);
            let e = email.filter((e) => !emIds.includes(e));
            if (e.length > 0) {
              err = "EmailID Not found our system (" + e.join(",") + ")";
            }
            for (let i = 0; i < emlist; i++) {
              emaillist[emlist[i].email] = aguserStore.getName4email(
                emlist[i].email
              );
            }
          }
        }
      }
      if (err.length == 0) {
        if (unloc.length > 0) {
          for (let i = 0; i < unloc.length; i++) {
            let unlo = await MonApi.apost(GET_MAP_UNLOC_URI, {
              descriptions: [unloc[i].toLowerCase()],
            });
            if (unlo.length == 0) {
              err = "UNLOG Not found our system (" + unloc[i] + ")";
              i = i + unloc.length + 1;
            } else {
              un[unloc[i]] = unlo[0];
            }
          }
        }
      }
      if (err.length == 0) {
        for (let i = 0; i < jd.length; i++) {
          let l1 = jd[i];
          l1["POL *"] =
            un[Utils.getUNCodeFromLocationString(l1["POL *"]).toUpperCase()];
          l1["POD *"] =
            un[Utils.getUNCodeFromLocationString(l1["POD *"]).toUpperCase()];
          l1["FPOD *"] =
            un[Utils.getUNCodeFromLocationString(l1["FPOD *"]).toUpperCase()];
          if (l1["Routing"] != undefined && l1["Routing"].length > 0) {
            l1["Routing"] =
              un[
                Utils.getUNCodeFromLocationString(l1["Routing"]).toUpperCase()
              ];
          }
          if (
            l1["Relationship Manager (Email)"] != undefined &&
            l1["Relationship Manager (Email)"].length > 0
          ) {
            l1["Relationship Manager (Email)"] =
              emaillist[l1["Relationship Manager (Email)"]];
          }
          if (
            l1["Customer Service (Email)"] != undefined &&
            l1["Customer Service (Email)"].length > 0
          ) {
            l1["Customer Service (Email)"] =
              emaillist[l1["Customer Service (Email)"]];
          }
          let c = {
            tsCreated_Date_Time:l1["CartingDate(DD-MM-YYYY) *"],
            general: false,
            refer: false,
            ODC: false,
            palletization: false,
            none: false,
            commercialInvoice_filename_list: [],
            packingList_filename_list: [],
            shippingBill_filename_list: [],
            cartingPhotos_filename_list: [],
            mmSlip_filename_list: [],
            salesperson: l1["Relationship Manager (Email)"],
            customerService: l1["Customer Service (Email)"],
            mode: l1["Type(LCL/FCL/Air) *"],
            invoiceDetails: [
              {
                invoiceNo: l1["Invoice No"],
                HSCode: l1["HS Code"],
                marksNos: l1["Marks & Nos"],
                commodityType: l1["Commodity Type"],
              },
            ],
            cargoDetails: [
              {
                packageType: l1["Package Type *"],
                quantity: l1["Quantity *"],
                weight: {
                  value: 0,
                  unit: "Kgs",
                },
                chargeableWeight: {
                  value: 0,
                  unit: "Kgs",
                },
                volume: {
                  value: 0,
                  unit: "CBM",
                },
                totalWeight: {
                  value: l1["Total Weight(Kgs) *"],
                  unit: "Kgs",
                },
                totalVolume: {
                  value: l1["Total Volume(CBM) *"],
                  unit: "CBM",
                },
                dimensions: {
                  length: 0,
                  width: 0,
                  height: 0,
                  unit: "Cms",
                },
              },
            ],
            cargoDimensionUnit: "Cms",
            hazardous: false,
            nonStackable: false,
            shipperName: l1["Shipper Name *"],
            shippingBillNo: l1["Shipping Bill No *"],
            shippingBillDate: l1["Shipping Bill Date(DD-MM-YYYY) *"],
            IECCode: l1["IEC Code"],
            address: l1["Address *"],
            LeoDateTime: l1["Leo Date & Time(DD-MM-YYYYTHH:MM)"],
            consigneeName: l1["Consignee Name *"],
            consigneeAddress: l1["Consignee Address *"],
            CHAName: l1["CHA Name *"],
            CHANumber: l1["CHA Number *"],
            entityId: l1["Customer Name(Entity Code #)"],
            SHEDLocation: l1["SHED Location"],
            remarks_special_instrctions: l1["Remarks"],
            portOfReceipt: l1["Carted At *"],
            portOfLoading: l1["POL *"],
            portOfDischarge: l1["POD *"],
            finalPlaceOfDelivery: l1["FPOD *"],
            reefer: l1["Reefer(Yes/No)"],
            topLoading: l1["Top Loading(Yes/No)"],
            fumigation: l1["Fumigation(Yes/No)"],
            headLoad: l1["Head Load(Yes/No)"],
            doorLoad: l1["Door Load(Yes/No)"],
            netWeight: l1["Net Weight *"],
            CFSLocation: l1["CFS Location *"],
            reworkingPort: l1["Routing"],
            totalWeight: 10,
            totalNumPackages: 10,
            totalVolume: 10,
            isFromUpload: "Yes",
          };
          let totals = Utils.calcCargoDetails(
            c.cargoDetails,
            false,
            "Cms",
            c.mode,
            c.cargoDetails
          );
          c.totalWeight = totals.totTotalWeight;
          c.totalNumPackages = totals.totNumPackages;
          c.totalVolume = totals.totTotalVolume;
          let res = await MonApi.apost(
            `${process.env.REACT_APP_API_SERVER}/api/v1/cartingorder`,
            c
          );
          console.log(res);
        }
      }

      if (err.length > 0) {
        configStore.setModalMessage(err);
      }else{
        configStore.setModalMessage("Successfully Uploaded");
      }
      document.getElementById(parent).getElementsByTagName('input')[0].value = ""
      loader.hide()
    };

    reader.readAsArrayBuffer(file);
  };
  const change1 = (parent,files) => {
    const file = files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = async (e) => {
      loader.show()
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array", cellDates: true });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const data1 = XLSX.utils.sheet_to_json(sheet);
      let m = [
        "branchId *",
        "entityId *",
        "Cargo ReadinessDate(DD-MM-YYYY) *",
        "BookingDate(DD-MM-YYYY) *",
        "Origin *",
        "Destination *",
        "POR *",
        "POL *",
        "POD *",
        "FPOD *",
        "Package Type *",
        "Quantity *",
        "Total Weight(Kgs) *",
        "Total Volume(CBM) *",
        "Commodity Type *",
        "IncoTerms *",
      ];
      let n = ["Quantity *", "Total Weight(Kgs) *", "Total Volume(CBM) *"];
      let loc = [
        "Origin *",
        "Destination *",
        "POR *",
        "POL *",
        "POD *",
        "FPOD *",
      ];
      let ch = [
        "Origin custom clearance - Per Container",
        "Origin transport - Per Container",
        "Origin charges - Per Container",
        "Ocean freight destination charges - Per Container",
        "Destination transport - Per Container",
        "Destination customer clearance - Per Container",
      ];
      let err = "";
      let unloc = [];
      let enitty = [];
      let branch = [];
      let jd = [];
      let un = {};

      const jsonData = data1.map((row) => {
        Object.keys(row).forEach((key) => {
          if (row[key] instanceof Date) {
            row[key] = formatDate(row[key]);
          }
        });
        return row;
      });
      if(jsonData.length==0){
        err = "No data"
      }
      for (let i = 0; i < jsonData.length; i++) {
        if (err.length == 0) {
          let l1 = jsonData[i];
          let k = Object.keys(l1);
          for (let j = 0; j < k.length; j++) {
            if (l1[k[j]] != undefined) {
              l1[k[j]] = l1[k[j]].toString().trim();
            }
          }
          for (let j = 0; j < m.length; j++) {
            if (l1[m[j]] == undefined || l1[m[j]].length == 0) {
              err = "Row " + (i + 2) + ": Required - " + m[j];
              j = m.length + 1;
            }
          }
          if (err.length == 0) {
            for (let j = 0; j < n.length; j++) {
              let l3 = Utils.toNum(l1[n[j]]);
              if (l3 != 0) {
                l1[n[j]] = l3;
              } else {
                err = "Row " + (i + 2) + ": Invalid Value - " + n[j];
              }
            }
          }
          if (err.length == 0) {
            let pt = packagetype[l1["Package Type *"].toLowerCase()];
            if (pt == undefined) {
              err =
                "Row " +
                (i + 2) +
                ": Invalid Package Type - (" +
                Object.values(packagetype).join(",") +
                ")";
            }
          }
          if (err.length == 0) {
            let cl = commodityList[l1["Commodity Type *"].toLowerCase()];
            if (cl == undefined) {
              err = "Row " + (i + 2) + ": Invalid Commodity Type";
            }
          }
          if (err.length == 0) {
            let IT = incoTermsList[l1["IncoTerms *"].toLowerCase()];
            if (IT == undefined) {
              err =
                "Row " +
                (i + 2) +
                ": Invalid IncoTerms - (" +
                Object.values(incoTermsList).join(",") +
                ")";
            }
          }
          if (err.length == 0) {
            if (!isValidDate(l1["Cargo ReadinessDate(DD-MM-YYYY) *"])) {
              err =
                "Row " +
                (i + 2) +
                ": Invalid Format - Cargo ReadinessDate(DD-MM-YYYY) *";
            } else {
              l1["Cargo ReadinessDate(DD-MM-YYYY) *"] = convertDate(
                l1["Cargo ReadinessDate(DD-MM-YYYY) *"]
              );
            }
          }
          if (err.length == 0) {
            if (!isValidDate(l1["BookingDate(DD-MM-YYYY) *"])) {
              err =
                "Row " +
                (i + 2) +
                ": Invalid Format - BookingDate(DD-MM-YYYY) *";
            } else {
              l1["BookingDate(DD-MM-YYYY) *"] = convertDate(
                l1["BookingDate(DD-MM-YYYY) *"]
              );
            }
          }
          if (err.length == 0) {
            for (let j = 0; j < loc.length; j++) {
              unloc.push(
                Utils.getUNCodeFromLocationString(l1[loc[j]]).toUpperCase()
              );
            }
          }
          l1["charges"] = {};
          l1["chargescur"] = {}
          if (err.length == 0) {
            for (let j = 0; j < ch.length; j++) {
              let l3 = Utils.toNum(l1[ch[j]]);
              if (l3 != 0) {
                let cur = l1[ch[j].replace("Per Container", "Currency")]
                if(cur==undefined || cur.length==0 || currencyList.indexOf(cur.toUpperCase())==-1){
                  err = "Row " + (i + 2) + ": Please Check "+ch[j].replace("Per Container", "Currency");
                }else{
                  l1["charges"][ch[j].replace(" - Per Container", "")] = l3;
                  l1["chargescur"][ch[j].replace(" - Per Container", "")] = cur.toUpperCase();
                }
              }
            }
            if (Object.keys(l1["charges"]).length == 0 && err.length==0) {
              err = "Row " + (i + 2) + ": Please Check Charges";
            }
          }
          if (err.length == 0) {
            enitty.push(l1["entityId *"]);
            branch.push(l1["branchId *"]);
            let br = l1["branchId *"].split("_");
            console.log(br);
            if (br.length < 2 || br[0] != l1["entityId *"]) {
              err = "Row " + (i + 2) + ": Please Check branchId *";
            }
          }
          jd.push(l1);
        } else {
          i = jsonData.length + 1;
        }
      }
      let enlist = [];
      let brlist = [];
      if (err.length == 0) {
        unloc = unloc.filter((item, index) => unloc.indexOf(item) === index);
        enitty = enitty.filter((item, index) => enitty.indexOf(item) === index);
        branch = branch.filter((item, index) => branch.indexOf(item) === index);
        if (enitty.length > 0) {
          enlist = await MonApi.find("SHEntities", {
            entityId: { $in: enitty },
          });
          if (enlist.length == 0) {
            err =
              "Entity Code # Not found our system (" + enitty.join(",") + ")";
          } else {
            let entityIds = enlist.map((item) => item.entityId);
            let e = enitty.filter((e) => !entityIds.includes(e));
            if (e.length > 0) {
              err = "Entity Code # Not found our system (" + e.join(",") + ")";
            }
          }
        }
      }
      if (err.length == 0) {
        if (branch.length > 0) {
          brlist = await MonApi.find("SHBranches", {
            branchId: { $in: branch },
          });
          if (brlist.length == 0) {
            err = "branchId # Not found our system (" + branch.join(",") + ")";
          } else {
            let branchIds = brlist.map((item) => item.branchId);
            let e = branch.filter((e) => !branchIds.includes(e));
            if (e.length > 0) {
              err = "branchId # Not found our system (" + e.join(",") + ")";
            }
            for (let i = 0; i < brlist.length; i++) {
              let br = brlist[i]["branchId"].split("_");
              if (br.length < 2 || br[0] != brlist[i]["entityId"]) {
                err = "Please Check branchId *(" + brlist[i]["branchId"] + ")";
                i = brlist.length + 1;
              }
            }
          }
        }
      }
      if (err.length == 0) {
        if (unloc.length > 0) {
          for (let i = 0; i < unloc.length; i++) {
            let unlo = await MonApi.apost(GET_MAP_UNLOC_URI, {
              descriptions: [unloc[i].toLowerCase()],
            });
            if (unlo.length == 0) {
              err = "UNLOG Not found our system (" + unloc[i] + ")";
              i = i + unloc.length + 1;
            } else {
              un[unloc[i]] = unlo[0];
            }
          }
        }
      }
      if(err.length==0){
        let entitylist = {}
        let branchlist = {}
        for (let i = 0; i < enlist.length; i++) {
          entitylist[enlist[i]['entityId']] = enlist[i]
        }
        for (let i = 0; i < brlist.length; i++) {
          branchlist[brlist[i]['branchId']] = brlist[i]
        }
        for (let i = 0; i < jd.length; i++) {
          for (let j = 0; j < loc.length; j++) {
            jd[i][loc[j]] = un[Utils.getUNCodeFromLocationString(jd[i][loc[j]]).toUpperCase()];
          }
          let booking = await getBookingdata(loginStore.userRec.email,"LCL",jd[i],branchlist[jd[i]['branchId *']],entitylist[jd[i]['entityId *']])
          console.log(booking)
        }
      }
      if (err.length > 0) {
        configStore.setModalMessage(err);
      }else{
        configStore.setModalMessage("Successfully Uploaded");
      }
      document.getElementById(parent).getElementsByTagName('input')[0].value = ""
      loader.hide()
    };

    reader.readAsArrayBuffer(file);
  };
  const change2 = (parent,files) => {
    const file = files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = async (e) => {
      loader.show()
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array", cellDates: true });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const data1 = XLSX.utils.sheet_to_json(sheet);
      let m = [
        "branchId *",
        "entityId *",
        "Cargo ReadinessDate(DD-MM-YYYY) *",
        "BookingDate(DD-MM-YYYY) *",
        "Origin *",
        "Destination *",
        "POR *",
        "POL *",
        "POD *",
        "FPOD *",
        "Container Type *",
        "Number of Containers *",
        "Weight Per Container(Kgs) *",
        "Commodity Type *",
        "IncoTerms *",
        "SCAC *"
      ];
      let n = ["Number of Containers *", "Weight Per Container(Kgs) *"];
      let loc = [
        "Origin *",
        "Destination *",
        "POR *",
        "POL *",
        "POD *",
        "FPOD *",
      ];
      let ch = [
        "Origin custom clearance - Per Container",
        "Origin transport - Per Container",
        "Origin charges - Per Container",
        "Ocean freight destination charges - Per Container",
        "Destination transport - Per Container",
        "Destination customer clearance - Per Container",
      ];
      let err = "";
      let unloc = [];
      let enitty = [];
      let branch = [];
      let jd = [];
      let un = {};

      const jsonData = data1.map((row) => {
        Object.keys(row).forEach((key) => {
          if (row[key] instanceof Date) {
            row[key] = formatDate(row[key]);
          }
        });
        return row;
      });
      let scac = []
      for (let i = 0; i < dataListStore.FCLCarrierList.length; i++) {
        scac.push(dataListStore.FCLCarrierList[i]['SCAC code'])
      }
      if(jsonData.length==0){
        err = "No data"
      }
      for (let i = 0; i < jsonData.length; i++) {
        if (err.length == 0) {
          let l1 = jsonData[i];
          let k = Object.keys(l1);
          for (let j = 0; j < k.length; j++) {
            if (l1[k[j]] != undefined) {
              l1[k[j]] = l1[k[j]].toString().trim();
            }
          }
          for (let j = 0; j < m.length; j++) {
            if (l1[m[j]] == undefined || l1[m[j]].length == 0) {
              err = "Row " + (i + 2) + ": Required - " + m[j];
              j = m.length + 1;
            }
          }
          if (err.length == 0) {
            for (let j = 0; j < n.length; j++) {
              let l3 = Utils.toNum(l1[n[j]]);
              if (l3 != 0) {
                l1[n[j]] = l3;
              } else {
                err = "Row " + (i + 2) + ": Invalid Value - " + n[j];
              }
            }
          }
          if (err.length == 0) {
            let ct = containerTypeList[l1["Container Type *"].toLowerCase()];
            if (ct == undefined) {
              err =
                "Row " +
                (i + 2) +
                ": Invalid Container Type - (" +
                Object.values(containerTypeList).join(",") +
                ")";
            }
          }
          if (err.length == 0) {
            let cl = commodityList[l1["Commodity Type *"].toLowerCase()];
            if (cl == undefined) {
              err = "Row " + (i + 2) + ": Invalid Commodity Type";
            }
          }
          if (err.length == 0) {
            let IT = incoTermsList[l1["IncoTerms *"].toLowerCase()];
            if (IT == undefined) {
              err =
                "Row " +
                (i + 2) +
                ": Invalid IncoTerms - (" +
                Object.values(incoTermsList).join(",") +
                ")";
            }
          }
          if (err.length == 0) {
            console.log(l1["Cargo ReadinessDate(DD-MM-YYYY) *"]);
            if (!isValidDate(l1["Cargo ReadinessDate(DD-MM-YYYY) *"])) {
              err =
                "Row " +
                (i + 2) +
                ": Invalid Format - Cargo ReadinessDate(DD-MM-YYYY) *";
            } else {
              l1["Cargo ReadinessDate(DD-MM-YYYY) *"] = convertDate(
                l1["Cargo ReadinessDate(DD-MM-YYYY) *"]
              );
            }
          }
          if (err.length == 0) {
            if (!isValidDate(l1["BookingDate(DD-MM-YYYY) *"])) {
              err =
                "Row " +
                (i + 2) +
                ": Invalid Format - BookingDate(DD-MM-YYYY) *";
            } else {
              l1["BookingDate(DD-MM-YYYY) *"] = convertDate(
                l1["BookingDate(DD-MM-YYYY) *"]
              );
            }
          }
          if (err.length == 0) {
            for (let j = 0; j < loc.length; j++) {
              unloc.push(
                Utils.getUNCodeFromLocationString(l1[loc[j]]).toUpperCase()
              );
            }
          }
          l1["charges"] = {};
          l1["chargescur"] = {}
          if (err.length == 0) {
            for (let j = 0; j < ch.length; j++) {
              let l3 = Utils.toNum(l1[ch[j]]);
              if (l3 != 0) {
                let cur = l1[ch[j].replace("Per Container", "Currency")]
                if(cur==undefined || cur.length==0 || currencyList.indexOf(cur.toUpperCase())==-1){
                  err = "Row " + (i + 2) + ": Please Check "+ch[j].replace("Per Container", "Currency");
                }else{
                  l1["charges"][ch[j].replace(" - Per Container", "")] = l3;
                  l1["chargescur"][ch[j].replace(" - Per Container", "")] = cur.toUpperCase();
                }
              }
            }
            if (Object.keys(l1["charges"]).length == 0 && err.length==0) {
              err = "Row " + (i + 2) + ": Please Check Charges";
            }
          }
          if(err.length==0){
            l1["SCAC *"] = l1["SCAC *"].toUpperCase()
            if(scac.indexOf(l1["SCAC *"])==-1){
              err = "Row " + (i + 2) + ": Please Check SCAC *";
            }
          }
          if (err.length == 0) {
            enitty.push(l1["entityId *"]);
            branch.push(l1["branchId *"]);
            let br = l1["branchId *"].split("_");
            console.log(br);
            if (br.length < 2 || br[0] != l1["entityId *"]) {
              err = "Row " + (i + 2) + ": Please Check branchId *";
            }
          }
          jd.push(l1);
        } else {
          i = jsonData.length + 1;
        }
      }
      let enlist = [];
      let brlist = [];
      if (err.length == 0) {
        unloc = unloc.filter((item, index) => unloc.indexOf(item) === index);
        enitty = enitty.filter((item, index) => enitty.indexOf(item) === index);
        branch = branch.filter((item, index) => branch.indexOf(item) === index);
        if (enitty.length > 0) {
          enlist = await MonApi.find("SHEntities", {
            entityId: { $in: enitty },
          });
          if (enlist.length == 0) {
            err =
              "Entity Code # Not found our system (" + enitty.join(",") + ")";
          } else {
            let entityIds = enlist.map((item) => item.entityId);
            let e = enitty.filter((e) => !entityIds.includes(e));
            if (e.length > 0) {
              err = "Entity Code # Not found our system (" + e.join(",") + ")";
            }
          }
        }
      }
      if (err.length == 0) {
        if (branch.length > 0) {
          brlist = await MonApi.find("SHBranches", {
            branchId: { $in: branch },
          });
          if (brlist.length == 0) {
            err = "branchId # Not found our system (" + branch.join(",") + ")";
          } else {
            let branchIds = brlist.map((item) => item.branchId);
            let e = branch.filter((e) => !branchIds.includes(e));
            if (e.length > 0) {
              err = "branchId # Not found our system (" + e.join(",") + ")";
            }
            for (let i = 0; i < brlist.length; i++) {
              let br = brlist[i]["branchId"].split("_");
              if (br.length < 2 || br[0] != brlist[i]["entityId"]) {
                err = "Please Check branchId *(" + brlist[i]["branchId"] + ")";
                i = brlist.length + 1;
              }
            }
          }
        }
      }
      if (err.length == 0) {
        if (unloc.length > 0) {
          for (let i = 0; i < unloc.length; i++) {
            let unlo = await MonApi.apost(GET_MAP_UNLOC_URI, {
              descriptions: [unloc[i].toLowerCase()],
            });
            if (unlo.length == 0) {
              err = "UNLOG Not found our system (" + unloc[i] + ")";
              i = i + unloc.length + 1;
            } else {
              un[unloc[i]] = unlo[0];
            }
          }
        }
      }
      if(err.length==0){
        let entitylist = {}
        let branchlist = {}
        for (let i = 0; i < enlist.length; i++) {
          entitylist[enlist[i]['entityId']] = enlist[i]
        }
        for (let i = 0; i < brlist.length; i++) {
          branchlist[brlist[i]['branchId']] = brlist[i]
        }
        for (let i = 0; i < jd.length; i++) {
          for (let j = 0; j < loc.length; j++) {
            jd[i][loc[j]] = un[Utils.getUNCodeFromLocationString(jd[i][loc[j]]).toUpperCase()];
          }
          let booking = await getBookingdata(loginStore.userRec.email,"FCL (Factory/Factory)",jd[i],branchlist[jd[i]['branchId *']],entitylist[jd[i]['entityId *']])
          console.log(booking)
        }
      }
      
      if (err.length > 0) {
        configStore.setModalMessage(err);
      }else{
        configStore.setModalMessage("Successfully Uploaded");
      }
      loader.hide()
      document.getElementById(parent).getElementsByTagName('input')[0].value = ""
    };

    reader.readAsArrayBuffer(file);
  };
  return (
    <div>
      <table className="table is-bordered is-striped is-fullwidth is-hoverable ">
        <tbody>
          <tr>
            <td>
              <div className="title is-6">Carting Sheet</div>
            </td>
            <td>
              <div id="cartingupload">
                <input
                  type="file"
                  accept={".xlsx"}
                  style={{ fontSize: "0.8rem" }}
                  onChange={(e) => {
                    if (e.target.files.length > 0) {
                      const pattern = /^\S[\s\S]*\S$|^\S$/;
                      if (pattern.test(e.target.files[0]["name"])) {
                        change("cartingupload",e.target.files);
                      } else {
                        configStore.setModalMessage(
                          "Please Check File Name and Format"
                        );
                        return (e.target.value = "");
                      }
                    }
                  }}
                />
              </div>
            </td>

            <td>
              <a
                style={{ fontSize: "12px", textDecoration: "underline" }}
                className="is-link"
                href="cartingsheet.xlsx"
                download="cartingsheet.xlsx"
              >
                Download Carting Sheet Template
              </a>
            </td>
          </tr>

          <tr>
            <td>
              <div className="title is-6">LCL</div>
            </td>
            <td>
              <div id="lclbookingupload">
                <input
                  type="file"
                  accept={".xlsx"}
                  style={{ fontSize: "0.8rem" }}
                  onChange={(e) => {
                    if (e.target.files.length > 0) {
                      const pattern = /^\S[\s\S]*\S$|^\S$/;
                      if (pattern.test(e.target.files[0]["name"])) {
                        change1("lclbookingupload",e.target.files);
                      } else {
                        configStore.setModalMessage(
                          "Please Check File Name and Format"
                        );
                        return (e.target.value = "");
                      }
                    }
                  }}
                />
              </div>
            </td>

            <td>
              <a
                style={{ fontSize: "12px", textDecoration: "underline" }}
                className="is-link"
                href="lcl_port_to_port.xlsx"
                download="lcl_port_to_port.xlsx"
              >
                Download LCL Template
              </a>
            </td>
          </tr>

          <tr>
            <td>
              <div className="title is-6">FCL</div>
            </td>
            <td>
              <div id="fclbookingupload">
                <input
                  type="file"
                  accept={".xlsx"}
                  style={{ fontSize: "0.8rem" }}
                  onChange={(e) => {
                    if (e.target.files.length > 0) {
                      const pattern = /^\S[\s\S]*\S$|^\S$/;
                      if (pattern.test(e.target.files[0]["name"])) {
                        change2("fclbookingupload",e.target.files);
                      } else {
                        configStore.setModalMessage(
                          "Please Check File Name and Format"
                        );
                        return (e.target.value = "");
                      }
                    }
                  }}
                />
              </div>
            </td>

            <td>
              <a
                style={{ fontSize: "12px", textDecoration: "underline" }}
                className="is-link"
                href="fcl_port_to_port.xlsx"
                download="fcl_port_to_port.xlsx"
              >
                Download FCL Template
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
